import { render, staticRenderFns } from "./SearchAssets.vue?vue&type=template&id=3459fa6c&"
import script from "./SearchAssets.vue?vue&type=script&lang=js&"
export * from "./SearchAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports